const LOAD = 'server-sts/auth/LOAD';
const LOAD_SUCCESS = 'server-sts/auth/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/auth/LOAD_FAIL';
const LOGIN = 'server-sts/auth/LOGIN';
const LOGIN_SUCCESS = 'server-sts/auth/LOGIN_SUCCESS';
const LOGIN_FAIL = 'server-sts/auth/LOGIN_FAIL';
const LOGOUT = 'server-sts/auth/LOGOUT';
const LOGOUT_SUCCESS = 'server-sts/auth/LOGOUT_SUCCESS';
const LOGOUT_FAIL = 'server-sts/auth/LOGOUT_FAIL';

const IS_SESSION_EXPIRED = 'server-sts/auth/IS_SESSION_EXPIRED';
const IS_SESSION_EXPIRED_SUCCESS = 'server-sts/auth/IS_SESSION_EXPIRED_SUCCESS';
const IS_SESSION_EXPIRED_FAIL = 'server-sts/auth/IS_SESSION_EXPIRED_FAIL';




const initialState = {
  loaded: false,
  user:{},
  loginError: false,
  loggingIn:false,
  tokenExpired:false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        user: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };

    case IS_SESSION_EXPIRED:
      return {
        ...state,
        loading: true,

      };
    case IS_SESSION_EXPIRED_SUCCESS:
      return {
        ...state,
        tokenExpired:false,

      };
    case IS_SESSION_EXPIRED_FAIL:
      return {
        ...state,
        tokenExpired:true,
        error: action.error
      };

    case LOGIN:
      return {
        ...state,
        loggingIn: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        user: action.result,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        loggingIn: false,
        user: null,
        loginError: action.error,
      };
    case LOGOUT:
      return {
        ...state,
        loggingOut: true,
        logoutReason:action.reason
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        loggingOut: false,
        user: null
      };
    case LOGOUT_FAIL:
      return {
        ...state,
        loggingOut: false,
        logoutError: action.error
      };
    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (auth) => auth.get('/loadAuth')
  };
}

export function login(credentials) {
	
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: (auth) => auth.post('/login', {
      data: {
        username: credentials.username,
        password: credentials.password,
      }
    })
  };
}

export function isSessionExpired() {
  return {
    types: [IS_SESSION_EXPIRED, IS_SESSION_EXPIRED_SUCCESS, IS_SESSION_EXPIRED_FAIL],
    promise: (auth) => auth.post('/isSessionExpired')
  };
}



/*
export function loginAdmin(username, password) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: (client) => client.post('/login', {
      data: {
        username: username,
        password: password,
        admin: true,
      }
    })
  };
}*/


export function logout(reason="Session expirée") {
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: (auth) => auth.get('/logout'), reason
  };
}
